import createReducer from 'redux/createReducer';

import type {
  BasketBuilderExperienceSuggestionsResponse,
  BasketBuilderExperienceEligibilityResponse,
} from 'api/definitions/basket-builder-experience';
import type { TransformedProducts } from 'redux/transforms/transform-products-and-recommendations-into-legacy-format';
import type { LegacyProductReference } from 'constants/products';

import {
  GET_BASKET_SUGGESTIONS,
  GET_BASKET_ELIGIBILITY,
} from 'redux/modules/basket-builder-experience/actions/types';

import type {
  BasketBuilderExperienceState,
  BasketBuilderExperienceRequestState,
  BasketBuilderExperienceSuccessState,
} from 'redux/modules/basket-builder-experience/types';

import { initialState } from '../state';

type BasketBuilderExperienceSuggestionsFetcherResult = Pick<
  TransformedProducts<BasketBuilderExperienceSuggestionsResponse>,
  'eligibility' | 'metadata'
> & {
  suggestions: LegacyProductReference[];
};

export type BasketBuilderExperienceSuggestionsRequestAction = {
  start: number;
};

export type BasketBuilderExperienceSuggestionsSuccessAction = {
  result: BasketBuilderExperienceSuggestionsFetcherResult;
};

export type BasketBuilderExperienceEligibilitySuccessAction = {
  result: BasketBuilderExperienceEligibilityResponse;
};

const getBasketBuilderExperienceEligibilityRequest = (state: BasketBuilderExperienceState) => ({
  ...state,
  eligibility: undefined,
});

const getBasketBuilderExperienceEligibilitySuccess = (
  state: BasketBuilderExperienceState,
  { result }: BasketBuilderExperienceEligibilitySuccessAction,
) => ({
  ...state,
  eligibility: result,
});

const getBasketBuilderExperienceSuggestionsRequest = (
  state: BasketBuilderExperienceState,
  { start }: BasketBuilderExperienceSuggestionsRequestAction,
): BasketBuilderExperienceRequestState | BasketBuilderExperienceSuccessState => ({
  ...state,
  loading: !start,
  loadingMore: !!start,
});

const getBasketBuilderExperienceSuggestionsSuccess = (
  state: BasketBuilderExperienceState,
  {
    result: { eligibility, suggestions, metadata },
  }: BasketBuilderExperienceSuggestionsSuccessAction,
): BasketBuilderExperienceRequestState | BasketBuilderExperienceSuccessState => ({
  ...state,
  loading: false,
  loadingMore: false,
  eligibility,
  suggestions,
  hasNextPage: metadata.hasNextPage,
  totalResults: metadata.totalResults,
});

const actionTypeReducerMap = [
  [GET_BASKET_ELIGIBILITY.request, getBasketBuilderExperienceEligibilityRequest],
  [GET_BASKET_ELIGIBILITY.success, getBasketBuilderExperienceEligibilitySuccess],
  [GET_BASKET_SUGGESTIONS.request, getBasketBuilderExperienceSuggestionsRequest],
  [GET_BASKET_SUGGESTIONS.success, getBasketBuilderExperienceSuggestionsSuccess],
] as const;

export type PayloadMap = ReducerMapTupleToRecord<typeof actionTypeReducerMap>;
export default createReducer(initialState, actionTypeReducerMap);
